<dx-button text="Decline" type="danger" (onClick)="onDeclinedClick($event)" >
</dx-button>

<form-popup [(visible)]="isDeclinedMerchantPopupOpened" titleText="Declined" buttonSavedText="Decline Registration"
    (save)="onConfirmDeclinedClick($event)">
    <app-rich-form [colCount]="1" [cardData]="data" [formwidth]="350" [items]="formUiWidgets"
        (dataChanged)="dataChanged($event)">
    </app-rich-form>
</form-popup>